import { inViewport } from '../lib/tools';

export default class SystemVideo {

  init() {
    this.mobileSrc = this.node.getAttribute('data-mobile-src') || this.desktopSrc;
    this.desktopSrc = this.node.getAttribute('data-desktop-src');
    
    if (!this.mobileSrc && !this.desktopSrc) {
      return;
    }
    
    window.addEventListener('scroll', () => {
      this.showVideo();
    });
    
    this.showVideo();
  }
  
  showVideo() {
    if (!inViewport(this.node)) {
      return;
    }
    
    const src = (window.innerWidth < 768) ? this.mobileSrc : this.desktopSrc;
    
    if (this.node.src === src) {
      return;
    }
    
    this.node.addEventListener('canplay', () => {
      setTimeout(() => {
        this.node.style.opacity = 1;
      }, 1000);
    }, { once: true });
    
    this.node.style.opacity = 0;
    this.node.src = src;
  }
  
}